var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg096Video(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5C3.34315 3 2 4.34315 2 6V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V6C22 4.34315 20.6569 3 19 3ZM20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6V18ZM16.5 11.13L9.49999 7.13C9.19059 6.95137 8.80939 6.95137 8.49999 7.13C8.18936 7.30934 7.99857 7.64131 7.99999 8V16C7.99857 16.3587 8.18936 16.6907 8.49999 16.87C8.6524 16.9564 8.82482 17.0012 8.99999 17C9.17517 17.0012 9.34759 16.9564 9.49999 16.87L16.5 12.87C16.8133 12.6924 17.0069 12.3601 17.0069 12C17.0069 11.6399 16.8133 11.3076 16.5 11.13ZM9.99999 9.72L14 12L9.99999 14.28V9.72Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg096Video);
export default __webpack_public_path__ + "static/media/096-video.4c9417693ce6186d514008fb7740b15a.svg";
export { ForwardRef as ReactComponent };